import React from 'react'
import { Autocomplete, TextField } from "@mui/material";
import { useSelector } from 'react-redux';

export default function MovieList({ onMovieChange }) {
    let movies = useSelector((state)=>state.moviesRes.movies.response||[])
  return (
    <div style={{ width: "78%" }}>
      <h3>Total Movies: {movies.length}</h3>
    <Autocomplete
      disablePortal
      options={movies?.map((e) => e.title)}
      onChange={(event, value) => {
        const selectedMovie = movies.find((movie) => movie.title === value);
        onMovieChange(selectedMovie?.title);
    }}
      sx={{
        backgroundColor: "white",
        "& .MuiInputBase-root": {
          height: 36,
          padding: "0 8px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#ccc",
        },
        "& .MuiAutocomplete-input": {
          padding: "0 !important",
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Movies List"
          InputLabelProps={{
            sx: {
              fontSize: "0.875rem",
              transform: "translate(14px, 8px) scale(1)",
              "&.MuiInputLabel-shrink": {
                transform: "translate(14px, -5px) scale(0.75)",
              },
            },
          }}
          />
        )}
      />
    </div>
  );
}
